import * as React from 'react';
import CheckBox from '../../CheckBox/CheckBox';
import { IDocument } from '../../../infrastructure/interfaces';
import { productType } from '../../../infrastructure/ProductType';
import './AdditionalInfoEditorForm.css';

export interface IAditionalEditorFormProps {
  onFieldChange(value: string | boolean, field: string): void;
  document: IDocument;
}

export default class AdditionalInfoEditorForm extends React.Component<IAditionalEditorFormProps> {
  
  textPrompt() {
    if (this.props.document.type === productType.Postcard) {
      return "Enter optional message for the back of the postcard"
    } 
    if (this.props.document.type === productType.Poster){
      return "Enter the poster title"
    }
    else {
      return "Enter subheadline for front cover"
    }
  }

  render() {
    return (
      <div className="additional-text-container">
        {(this.props.document.type === productType.Poster ) ? 
          null :
          <div className="label-container_checkBox company-info-step">
            <CheckBox
              onClick={() => this.props.onFieldChange(!this.props.document.additionalInfo.isEnabled, 'isEnabled')}
              checked={this.props.document.additionalInfo.isEnabled}
              disabled={false} />
            <span className="label-settings_checkBox">
              {this.props.document.type === productType.Postcard ? 
              "Show optional message" 
              : "Show additional text" }
            </span>
          </div>
        }
        <input
      
         className="additional-text"
         placeholder="Date"
         maxLength={50}
         value={this.props.document.additionalInfo.date}
         hidden={(this.props.document.type === productType.Postcard) || (this.props.document.type === productType.Poster)}
         onChange={e => this.props.onFieldChange(e.target.value, 'date') }/>

        <textarea rows={4} cols={50}
          className="additional-text"
          placeholder={this.textPrompt()}
          maxLength={this.props.document.type === productType.Postcard ? 200 : 40}
          value={this.props.document.additionalInfo.text}
          onChange={e => this.props.onFieldChange(e.target.value, 'text')}
        >
        </textarea>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/DocumentEditor/AdditionalInfoForm/AdditionalInfoEditorForm.tsx